var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_860)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.07 2.92889C19.2194 2.60086 19.2774 2.23855 19.2378 1.88028C19.1982 1.52202 19.0625 1.18111 18.8451 0.893619C18.6277 0.606124 18.3366 0.382729 18.0027 0.247059C17.6687 0.111388 17.3043 0.0684852 16.948 0.122888C7.35 1.59489 0 9.88289 0 19.8909C0 30.9369 8.954 39.8909 20 39.8909C31.046 39.8909 40 30.9369 40 19.8909C39.9998 19.7042 39.9972 19.5175 39.992 19.3309C39.982 18.9703 39.8747 18.6191 39.6814 18.3146C39.4881 18.01 39.216 17.7634 38.894 17.6008C38.572 17.4383 38.212 17.3658 37.8521 17.3912C37.4923 17.4166 37.146 17.5388 36.85 17.7449C34.6922 19.2476 32.1005 20 29.4735 19.8864C26.8464 19.7728 24.3294 18.7994 22.3095 17.1159C20.2895 15.4325 18.8784 13.1321 18.2931 10.5686C17.7078 8.00502 17.9808 5.3202 19.07 2.92689V2.92889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.34e05adbd95542fadaec6935205632e1.svg";
export { ForwardRef as ReactComponent };